import { paddleCountriesKeyValue, EPaddleCountryKeyEU, EPaddleCountryKey, EPaddleCountryKeySanctioned } from "@devowl-wp/paddle-countries";
import { iso3166OneAlpha2KeyValue } from "@devowl-wp/iso-codes";
import { useMemo } from "react";

/**
 * Get a priority-sorted list of all countries.
 */
function usePriorityCountries(type) {
  return useMemo(() => {
    const valueMap = {};
    const sortable = [];
    const lang = document.querySelector("html").getAttribute("lang").substr(0, 2);
    switch (type.toLowerCase()) {
      case "iso-3166-1-alpha-2":
        {
          const all = iso3166OneAlpha2KeyValue(lang);
          // Prepare sortable array
          for (const key in all) {
            valueMap[key] = all[key];
            sortable.push({
              key,
              label: all[key]
            });
          }
          break;
        }
      case "paddle":
        {
          const all = paddleCountriesKeyValue(lang);
          // Prepare sortable array
          for (const key in all) {
            valueMap[key] = all[key];
            sortable.push({
              key,
              label: all[key]
            });
          }
          break;
        }
      default:
        throw new Error(`${type} not yet implemented!`);
    }
    sortable.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      } else if (a.label > b.label) {
        return 1;
      } else {
        return 0;
      }
    });

    // Split by EU countries and non-EU countries
    const sanctionedCountries = Object.values(EPaddleCountryKeySanctioned).map(String);
    const euCodes = Object.values(EPaddleCountryKeyEU).map(String);
    const euPriorityList = [EPaddleCountryKeyEU.Germany, EPaddleCountryKeyEU.Austria].map(String);
    const restOfTheWorldPriorityList = [EPaddleCountryKey.Switzerland].map(String);
    const groups = {
      eu: euPriorityList.map(key => ({
        key,
        label: valueMap[key]
      })).concat(sortable.filter(_ref => {
        let {
          key
        } = _ref;
        return euCodes.indexOf(key) > -1;
      }).filter(_ref2 => {
        let {
          key
        } = _ref2;
        return euPriorityList.indexOf(key) === -1;
      })),
      restOfTheWorld: restOfTheWorldPriorityList.map(key => ({
        key,
        label: valueMap[key]
      })).concat(sortable.filter(_ref3 => {
        let {
          key
        } = _ref3;
        return euCodes.indexOf(key) === -1;
      }).filter(_ref4 => {
        let {
          key
        } = _ref4;
        return restOfTheWorldPriorityList.indexOf(key) === -1;
      }).filter(_ref5 => {
        let {
          key
        } = _ref5;
        return sanctionedCountries.indexOf(key) === -1;
      }))
    };
    return groups;
  }, []);
}
export { usePriorityCountries };